<div class="card card-custom" style="padding: 20px 15px; margin-bottom: 20px">
    <div class="row">
        <div class="col-md-12">
            <div class="card pt-3 pb-3 ps-3 pe-3">
                <table class="table">
                    <thead>
                        <tr>
                            <td></td>
                            <td>Metric</td>
                            <td>Imperial</td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="stdCalcResults?.length">
                            <ng-container *transloco="let t; read: 'CALC_OUTPUT.LABEL.STANDARD_OUTPUT'">
                                <tr *ngFor="let output of stdCalcResults">
                                    <td>{{ t(output.displayText) }}</td>
                                    <td>{{ output.displayMetricValue }}</td>
                                    <td>{{ output.displayImperialValue }}</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div *ngIf="!stdCalcResults?.length" class="no-datafound">
                <p>{{ 'CALC_OUTPUT.STD_OUTPUT.NO_CALC_OUTPUT' | transloco }}</p>
            </div>

            <div class="setting_section">
                <a (click)="openCalculationResultSettingsModal()" class="setting_icon">
                    <i class="fa fa-cog" aria-hidden="true"></i>
                </a>
                <div *ngIf="showAdvanced()">
                    <a href="javascript:void(0)" class="btn secondary-ebtn statistic_icon" (click)="showAdvancedOutputpanel()">
                        {{ 'CALC_OUTPUT.LABEL.STANDARD_OUTPUT.Show more statistics' | transloco }}
                        &nbsp;
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
